export default {
  Problem_feedback: 'Please enter a problem and suggestion',
  contact_information: 'Please enter the contact information',
  contact_information_the: 'Please enter the contact information',
  import: 'input',
  Please_enter: 'Please enter ',
  Old_password: 'old password',
  New_password: 'new password',
  Required: 'Required',
  Enteranewpassword: 'Enter a new password',
  Confirm_new_password: 'Confirm new password',
  mobile: 'Mobile phone number',
  QQ: 'QQ number',
  postbox: 'mailbox',
  contact_you: 'Convenient to contact you',
  question: 'Please enter your question',
  Characters_up: '6-16 characters',
  address: 'Please enter a detailed address',
  renewal_contact: 'Please enter the renewal contact information',
  ple_contact_name: 'Please enter the contact name',
  Please_enter_withdrawal: 'Please enter withdrawal ',
  Number_of_cards: 'Number of cards',
  Pleasechooseanagent: 'Please choose an agent',
  Pleaseenterthequantity: 'Please enter the quantity',
  Pleaseentertheuserprefixnickname: 'Please enter the user prefix nickname (2-7 digits)',
  PleaseEnterImei: 'Please enter the 15-digit IMEI number',
  Remarkswithin: 'Remarks: within 100 words',
  Pleaseselectaunit: 'Please select a company',
  Pleaseselectagrouptojoin: 'Please select a group to join',
  Pleaseentertheunitname: 'Please enter the company name',
  companynamerequired: '(required: 4-20 characters, letters, numbers)',
  Pleaseenterloginaccount: 'Please enter the login account',
  loginaccountrequired: '(required: 6-20 letters and numbers)',
  Pleaseenteryourpassword: 'Please enter your login password',
  loginpasswordrequired: '(required: 6-16 letters, numbers)',
  Pleaseenteracontactname: 'Please enter the contact name',
  contactnamerequired: '(required: 2-10 characters, letters, numbers)',
  Pleaseenteraprefixname: 'Please enter the prefix name',
  prefixnamerequired: '(required: 2-12 characters, letters, numbers)',
  Contactnamerequired: 'Contact name (required: 2-10 characters)',
  mobilephonenumber: 'Mobile phone number (optional)',
  Enteremailaddress: 'Enter email address (optional)',
  Enterdetailedaddress: 'Enter detailed address (optional)',
  Pleaseenteragroupname: 'Please enter a group name (required: 2-15 characters)',
  Groupnamerequired: 'Group name (required: 2-15 characters)',
  Pleasetypeyourphonenumber: 'Please enter your phone number',
  Pleaseinputtheemailaddress: 'Please input the email address',
  Pleaseenterthemailingaddress: 'Please enter the mailing address',
  RequiredPleaseenterusernickname: '(Required) Please enter user nickname',
  Pleasemobilephonenumber: '(Optional) Please enter an 11-digit mobile phone number',
  PleaseentertheoriginalIMEInumber: 'Please enter the original 15-digit IMEI number',
  PleaseenterthenewIMEInumber: 'Please enter the new 15-digit IMEI number',
  Pleaseenteraverificationcode: 'Please enter a 4-digit verification code',
  Pleaseenterthemobilephonenumbertobebound: 'Please enter the mobile phone number to be bound',
  PleaseenteragroupnameTow: 'Please enter a group name',
  Pleaseenterusername: 'Please enter user name',
  Fencenamerequired: 'Fence name (required: 1-15 characters)',
  Pleaseenterthefencename: 'Please enter the fence name',
  Pleaseselectatime: 'Please select a time',

  please_rest_password: 'For the security of your account, it is recommended to reset your login password first',
  TheLastGroupUnderTheUnitCannotBeDeleted: 'The last group under the unit cannot be deleted',
}
